/** Client for the sk-hire v2 DPDP compliance API. */
import axiosInstance from '../../api/axiosInstance';
import {
  HireMatch_Consent_Stats_Url,
  HireMatch_Consent_Expiring_Url,
  HireMatch_Consent_Events_Url,
  HireMatch_Erasures_Url,
  HireMatch_Candidate_Erasure_Url,
} from '../../api/endpoints';

export interface ConsentStats { active: number; expiring: number; expired: number; erased: number }
export interface ExpiringItem { candidateId: string; name: string; purpose: string; ttlExpiresAt: string; daysLeft: number }
export interface ConsentEventItem { id: string; candidateId: string; name: string; eventType: string; purpose: string; recordedAt: string }
export interface ErasureItem { id: string; candidateId: string; name: string; vectorsNulled: number; summariesNulled: number; emailHashNulled: boolean; recordedAt: string }

export async function getConsentStats(): Promise<ConsentStats> {
  const { data } = await axiosInstance.get<ConsentStats>(HireMatch_Consent_Stats_Url);
  return data;
}
export async function getExpiring(): Promise<ExpiringItem[]> {
  const { data } = await axiosInstance.get<ExpiringItem[]>(HireMatch_Consent_Expiring_Url);
  return Array.isArray(data) ? data : [];
}
export async function getConsentEvents(): Promise<ConsentEventItem[]> {
  const { data } = await axiosInstance.get<ConsentEventItem[]>(HireMatch_Consent_Events_Url);
  return Array.isArray(data) ? data : [];
}
export async function getErasures(): Promise<ErasureItem[]> {
  const { data } = await axiosInstance.get<ErasureItem[]>(HireMatch_Erasures_Url);
  return Array.isArray(data) ? data : [];
}
export async function eraseCandidate(id: string): Promise<void> {
  await axiosInstance.post(HireMatch_Candidate_Erasure_Url(id));
}
